import type { BoxProps } from '@chakra-ui/react'
import { Box, Button } from '@chakra-ui/react'
import { Product } from 'BrokerTsLib/src/enums'
import { useState } from 'react'
import { useApp } from '../../hooks/useApp'
import { BusinessDiscounts } from './BusinessDiscounts'
import { IndividualDiscounts as IndividualDiscountsCarkulka } from './carkulka/IndividualDiscounts'
import { IndividualDiscounts as IndividualDiscountsCestovko } from './cestovko/IndividualDiscounts'
import { IndividualDiscounts as IndividualDiscountsChaloupka } from './chaloupka/IndividualDiscounts'

export const Discounts = ({ onDiscountsLoaded }: { onDiscountsLoaded: () => void }) => {
  const [opened, setOpened] = useState(true)
  const { app, product } = useApp()

  const closedLabel = 'Nastavit slevy'
  const openedLabel = 'Skrýt slevy'
  const headerFooterSx: BoxProps = {
    display: 'grid',
    w: '100%',
    justifyItems: 'end',
  }

  return (
    <Box sx={{ w: '100%', display: 'grid', gap: 4 }}>
      <Box as="header" sx={headerFooterSx}>
        <Button variant="outline" onClick={() => setOpened(!opened)}>
          {opened ? openedLabel : closedLabel}
        </Button>
      </Box>

      <Box sx={{ display: opened ? 'grid' : 'none', gap: 8 }}>
        {app == 'carkulka' &&
          <IndividualDiscountsCarkulka />
        }
        {app == 'cestovko' &&
          <IndividualDiscountsCestovko />
        }
        {app == 'chaloupka' && product != Product.LiabilityInsurance &&
          <IndividualDiscountsChaloupka />
        }

        <BusinessDiscounts onDiscountsLoaded={onDiscountsLoaded} />

      </Box>
    </Box>
  )
}
